export const defaultPagesProps = () => ({
    backgroundImage: "",
    backgroundStyle: "background-size: contain; background-position: center center; background-repeat: no-repeat;",
    differentFirstHeader: false,
    differentFirstFooter: false,
    size: "a4",
    first: {
        header: "",
        footer: "",
        headerHeight: "95px",
        footerHeight: "95px"
    },
    general: {
        header: "",
        footer: "",
        headerHeight: "95px",
        footerHeight: "95px"
    }
});
export const defaultDocument = () => ({
    name: "",
    id: "",
    applicationId: "",
    template: "",
    rules: [],
    repeatableParameters: [],
    blockCounter: 0,
    repeatableBlockCounter: 0,
    richTextCounter: 0,
    pages: defaultPagesProps()
});

export const defaultPagesState = () => ({
    backgroundImage: {
        differentFirstPage: false,
        tab: "general"
    },
    template: {
        differentFirstPage: false,
        tab: "general"
    },
    header: {
        differentFirstPage: false,
        tab: "general"
    },
    footer: {
        differentFirstPage: false,
        tab: "general"
    }
});

export const defaultSelectedBlock = () => ({
    uuid: "",
    name: "",
    description: "",
    conditions: {
        statement: "",
        conditions: []
    }
});
export const defaultSelectedRepeatableBlock = () => ({
    uuid: "",
    name: "",
    parentUuid: "",
    selection: [],
    sortBy: "",
    direction: "",
    conditions: {
        statement: "",
        conditions: []
    }
});
export const defaultFonts = () => [
    "EncodeSans",
    "EncodeSansCondensed",
    "Lato",
    "Merriweather",
    "Montserrat",
    "NotoSans",
    "NotoSerif",
    "OpenSans",
    "Oswald",
    "Raleway",
    "Roboto",
    "RobotoCondensed",
    "RobotoMono",
    "RobotoSlab"
];
